<!--
Accounting/Billing
Accounting/Customer invoice items
Accounting/Dispatchers' statements
Accounting/Dispatchers' statements Loads
Accounting/Dispatchers' statements Create

-->

<template>
	<div>
		<v-data-table
				class="elevation-1 data-table-module"
				:class="customClass"
				:headers="header"
				:items="list"
				:search="search"
				:custom-filter="onCustomFilter"
				:items-per-page="itemsPerPage"
				:page.sync="page"
				:sort-by="sortBy"
				:sort-desc="sortDesc"
				:custom-sort="onCustomSort"
				locale="en-US"
				@page-count="pageCount = $event"
				hide-default-footer
				hide-default-header
				hide-default-body
		>
			<template v-slot:header="{ props: { headers } }">
				<thead class="v-data-table-header">
				<tr>
					<th
							:class="[
                { 'orange--text': sortBy === item.value },
                { 'filter-active': filterClasses[item.value] },
                { 'text-center': item.text === 'PPW' }
              ]"
							v-for="(item, index) in headers"
							:key="index"
							class="text-start sortable position-relative "
							:id="'container-' + item.value"
					>
						<div class="d-flex align-center head">
							<template v-if="!item.checkbox">
                    <span class="head-item__total" v-if="checkCalc(item)">
                <span class="green--text">{{ item.calcTotal.title }}: </span>
                <span v-if="item.calcTotal.prefix.status">{{
		                item.calcTotal.prefix.value
	                }}</span>
                <span>{{ calcTotal(item.calcTotal.key) }}</span>
                <span v-if="item.calcTotal.suffix.status">{{
		                item.calcTotal.suffix.value
	                }}</span>
              </span>
								<v-menu
										:attach="'#container-' + item.value"
										:nudge-width="300"
										:max-width="300"
										:min-width="300"
										nudge-bottom="30"
										:close-on-content-click="false"
										bottom
										:right="index !== headers.length - 1"
										:left="index === headers.length - 1 || index === headers.length - 2"
										v-if="item.func"
										:content-class="'table-dd'"
										transition="scale-transition"
								>
									<template v-slot:activator="{ on: menu, attrs }">
										<v-tooltip top color="teal">
											<template v-slot:activator="{ on: tooltip }">
                      <span
		                      v-bind="attrs"
		                      v-on="{ ...tooltip, ...menu }"
                      >{{ item.text.toLowerCase() === 'bol' ? 'Bol (files)' : item.text }}
                      </span>
											</template>
											<span>Filter</span>
										</v-tooltip>
									</template>
									<v-list>
										<v-list-item v-if="item.model === 'list'">
											<button @click="onFilteredAll(item)">Select all</button>
										</v-list-item>
										<v-list-item>
											<filter-table
													@change-sort="changeSort"
													@create-refresh="createRefresh"
													@filter-created="filterCreated"
													:data-filter="filtersList && filtersList[item.value]"
													:uniqId="uniqId"
													:model-filter="item.value"
													:type-filter="item.model"
													:label-filter="item.text"
													:filter-update="filterUpdate"
											/>
										</v-list-item>
									</v-list>
								</v-menu>
								<span v-else>{{ item.text }}</span>
								<v-tooltip v-if="item.sortable == true" color="orange" top>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
												v-bind="attrs"
												v-on="on"
												@click="toggleOrder(item.value)"
												icon
												x-small
												class="ml-4"
										>
											<v-icon
													:class="{ 'orange--text': sortBy === item.value }"
													class="sort-icon"
													size="14"
											>compare_arrows
											</v-icon
											>
										</v-btn>
									</template>
									<span>Sort</span>
								</v-tooltip>
							</template>
							<!-- Checkbox pick all -->
							<template v-else>
								<div>
									<span>Pick all</span>
									<v-checkbox @change="pickAll" :value="ifChecked"></v-checkbox>
								</div>
							</template>
						</div>
					</th>
				</tr>
				</thead>
			</template>

			<template v-slot:body="{ items }">
				<tbody>

				<tr
						v-for="(item, index) in items"
						:key="index"
						@dblclick="goTo(item, index)"
				>
					<td
							v-for="(i, indx) in header"
							:key="indx"
							:class="[
                    { 'filter-active': filterClasses[i.value] },
                    {'invo': i.value === 'invoice'}
                ]"
					>
						<template v-if="!i.checkbox">
							<div
									v-if="permissions['11'] && indx === header.length - 1 || permissions['11'] && i.del"
									class="d-flex eeee"
							>
<!--								:disabled="userData.name !== item.created_by && item.notes != null"-->
								<v-icon
										:disabled="userData.name == item.created_by && !item.notes"
						        class="ml-auto"
						        small
						        @click="checkRemove(item)"
								>
									mdi-delete
								</v-icon>
							</div>
							<!-- Eye for table -->
							<template v-if="i.icon">
								<div>
									<v-icon v-if="permissions['10'] || permissions['19'] || permissions['9']"
									        class="ml-auto" small @click="$emit('action-cell', item[i.icon.prop])"
									>{{ i.icon.name }}
									</v-icon>
								</div>
							</template>
							<template v-else>
                        <span v-if="!i.colorDetected">
                            {{ i.ppw ? '' : item[i.value] }}
                            <v-icon v-if="i.dollar" x-small>mdi-currency-usd</v-icon>
                        </span>
								<span
										v-else
										:class="[
                        { 'red--text': item[i.value] < 0 },
                        { 'green--text': item[i.value] > 0 },
                    ]"
								>{{ item[i.value] }}</span
								>
							</template>
							<template>
								<div v-if="i.previewDoc">
									<preview-doc v-if="permissions['19']" :link-doc="item.image ? item.image : item.file"/>
								</div>
							</template>
						</template>
						<template v-else>
							<div>
								<v-checkbox
										v-model="item.checked"
										@change="checkedItem(item, item.checked)"
								></v-checkbox>
							</div>
						</template>
						<template>
							<div v-if="i.options && item.invoice == 'true' " class="d-flex align-center justify-start">

								<preview-doc :color="'green'" :link-doc="item.invoice_url ? item.invoice_url : item.file" class=""/>
								<a
										:href="linkDownload(item.invoice_url)"
										class="v-btn"
										download
										rel="noopener noreferrer"
								>
									<v-icon medium color="green">mdi-download-outline</v-icon>
								</a>
							</div>
						</template>

						<template>
							<div v-if="i.ppw" class="d-flex align-center justify-start">
								<!-- Send -->
								<v-btn
										class="v-btn--icon v-btn--round qqq"
										download
										icon
										x-small
										:disabled="item.ppw_url == null"
										rel="noopener noreferrer"
										@click="sendPpwShow(item.load_id)"
								>
									<v-icon small color="green">mdi-send</v-icon>
								</v-btn>
								<!-- Watch ppw files -->
								<v-btn
										class="v-btn--icon v-btn--round www"
										download
										x-small
										:disabled="item.ppw_url == null"
										icon
										rel="noopener noreferrer"
										@click="showPpwFiles(item, index)"
								>
									<v-icon small color="green">mdi-eye</v-icon>
								</v-btn>
								<!-- <preview-doc :disable="item.ppw_url == null" :link-doc="item.ppw_url ? item.ppw_url : null" class=""/> -->
								<a
										:href="item.ppw_url"
										class="v-btn"
										download
										rel="noopener noreferrer"
								>
									<v-icon :disabled="item.ppw_url == null"
									        medium color="green">mdi-download-outline
									</v-icon>
								</a>
							</div>
						</template>
					</td>
				</tr>
				<!-- HERE -->

				<tr class="sticky" v-if="tableType === 'dispatchersStatements'">
					<td>n: <span class="filteredItems">{{ items.length }}</span> /
						{{ lengthOfFiltered != null ? lengthOfFiltered : dataTable.length }}
					</td>
					<td></td>
					<td></td>
					<td></td>
					<td v-if="isTfoot" class="firstLetter">Σ: {{ onSum('gross') }}</td>
					<td v-else></td>
					<td v-if="isTfoot" class="firstLetter">Σ: {{ onSum('count_load') }}</td>
					<td v-else></td>
					<td></td>
					<td v-if="isTfoot" class="firstLetter">Σ: {{ onSum('amount', 2) }}</td>
					<td v-else></td>
					<td></td>
					<td></td>
					<td></td>
				</tr>
				<tr v-else class="sticky">
					<td>n: <span class="filteredItems">{{ items.length }}</span> /
						{{ lengthOfFiltered != null ? lengthOfFiltered : dataTable.length }}
					</td>
				</tr>

				</tbody>
			</template>
			<template v-slot:top>
				<div class="d-flex" v-if="!showTop">
					<v-text-field
							v-model="search"
							@keyup.enter="onSearch"
							append-icon="search"
							label="Search"
							class="mx-4 search-table"
					></v-text-field>
					<div class="ml-auto d-flex">
						<v-btn
								x-small
								color="teal"
								@click="refreshFilters"
								class="mt-auto mb-5 mr-3"
						>Refresh Filters
						</v-btn
						>
					</div>
					<div class="mr-2 position-relative" id="count-items">
						<v-select
								class="count-items"
								attach="#count-items"
								:items="countItems"
								v-model="countItemsVal"
								label="Items per page"
								:menu-props="{ nudgeBottom: 30 }"
								@input="checkPages($event)"
						></v-select>
					</div>
				</div>
			</template>
		</v-data-table>

		<div class="pagination-wrap">
			<v-pagination
					v-if="pageCount > 1"
					v-model="page"
					:length="pageCount"
					:total-visible="7"
			></v-pagination>
		</div>
		<v-snackbar
				shaped
				top
				v-model="snackbar"
				elevation="24"
				:vertical="vertical"
		>
			Do you confirm the deletion?
			<v-card-actions>
				<v-flex d-flex justify-end>
					<v-btn
							small
							color="green"
							class="mt-0 ml-auto"
							text
							@click="deleteAction(index)"
					>Yes
					</v-btn
					>
					<v-btn small color="red" class="mt-0" text @click="snackbar = false"
					>Close
					</v-btn
					>
				</v-flex>
			</v-card-actions>
		</v-snackbar>
	</div>
</template>
<script>
import FilterTable from "./filter-table/filter-table";
import PreviewDoc from "@/shared/preview/preview-doc";
// helpers
import getUniqId from "@/helper/getUniqId";
import { getAppUrl } from "@/services";

export default {
	components: {
		FilterTable,
		PreviewDoc,
	},
	props: {
		flag: String,
		customClass: {
			type: String,
		},
		dataTable: {
			type: Array,
		},
		headerTable: {
			type: Array,
		},
		permissions: {
			type: Object,
		},
		sortByDefault: {
			type: String,
		},
		sortDescDefault: {
			type: Boolean,
		},
		update: {
			type: Boolean,
		},
		showTop: {
			type: Boolean
		},
		link: {
			type: Boolean,
		},
		isTfoot: {
			type: Boolean,
		},
		tableType: {
			type: String,
		},
	},
	data() {
		return {
			uniqId: { key: '', id: '' },
			dialog: false,
			loadIdToSend: null,
			mailRules: [ (v) => /^$|.+@.+\..+/.test(v) || "E-mail must be valid" ],
			ifChecked: false,
			vertical: true,
			data: null,
			search: "",
			sortBy: "",
			sortDesc: true,
			filterUpdate: false,
			page: 1,
			pageCount: 0,
			countItems: [ 5, 10, 15, 20, 50, 100, "All" ],
			itemsPerPage: 20,
			filtersMarker: {},
			filters: {},
			filtersList: {},
			checkClasses: {},
			countItemsVal: 20,
			itemRemove: null,
			snackbar: false,
			removeStart: false,
			showSend: false,
			lengthOfFiltered: null,
			userData: {},
		};
	},
	computed: {
		header() {
			return this.headerTable;
		},
		listValues() {
			const arr = [];
			for (let i = 0; i < this.headerTable.length; i++) {
				arr.push(this.headerTable[i].value);
			}
			return arr;
		},
		list: {
			get() {
				return this.data;
			},
			set(val) {
				this.data = val;
			},
		},
		filterClasses: {
			get: function() {
				return this.checkClasses;
			},
			set: function(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = arr[i].length ? true : false;
				}
				this.checkClasses = obj;
			},
		},
		dataTablelength() {
			return this.dataTable.length;
		},
	},
	created() {
		this.list = this.dataTable;
		for (let i = 0; i < this.header.length; i++) {
			this.filtersMarker[this.header[i].value] = true;
			this.checkClasses[this.header[i].value] = false;
			this.filters[this.header[i].value] = [];
			this.filtersList[this.header[i].value] = [];
		}
		this.setListsFilter(this.list);
	},
	async mounted() {
		this.$store.dispatch("actionPreloader", true);
		this.$store.dispatch("getDataUser").then((resp) => {
			if (resp.user) {
				Object.assign(this.userData, resp.user);
				this.$store.dispatch("actionPreloader", false);
			}
		});
		if (this.list[0]) {
			this.ifChecked = this.list.every((i) => i.checked === true);
		}
		if (this.ifChecked === true) {
			this.pickAll(true);
		}
		if (this.sortByDefault) {
			if (this.sortDescDefault === false) this.sortDesc = this.sortDescDefault;
			this.toggleOrder(this.sortByDefault);
		}
		this.setListsFilter(this.list);
		this.$store.watch(
			(state, getters) => getters.checkRefreshFilters,
			(newVal) => {
				if (newVal) {
					this.refreshFilters();
					this.$store.commit("SET_FILTER_CHECKED", false);
				}
			}
		);
	},
	methods: {
		linkDownload(url) {
			return getAppUrl + url;
		},
		onSearch() {
			// console.log('%c [  onSearch  ] ','color:#bada55',   );
		},
		onSum(key, sing) {
			return this.list.reduce((acc, item) => {
				acc += item[key];
				return acc;
			}, 0).toFixed(sing);
		},

		onCustomFilter(filter, search, items) {
			search = search.toString().toLowerCase();
			const id = items['id'].toString();
			return id.includes(search);
		},
		onFilteredAll(item) {
			this.filterCreated(item.value);
			this.uniqId = {
				id: getUniqId(),
				key: item.value
			};
		},
		showPpwFiles(item) {
			this.dialog = true;
			this.$store.dispatch('getListOfPpwFiles', item.load_id);
		},

		sendPpwShow(id) {
			this.loadIdToSend = id;
			this.showSend = true;
		},
		pickAll(e) {
			this.list.map(item => this.checkedItem(item, e));
		},
		checkedItem(item, value) {
			const indexOfChecked = this.list.findIndex(
				(i) => {
					if (!i.load_image_id) {
						return i.dispatcher_id === item.dispatcher_id;
					} else if (i.load_image_id) {
						return i.load_image_id === item.load_image_id;
					}
				}
			);

			this.list.length
				? (this.list[indexOfChecked].checked = value)
				: null;
			this.$emit('fill-checkedarr', item);
		},
		calcTotal(key) {
			let result = 0;
			for (const item of this.list) {
				result = item[key] + result;
			}
			return result.toFixed(2);
		},
		checkCalc(item) {
			if (item?.calcTotal) return true;
			return false;
		},
		deleteAction() {
			this.$emit("delete-action", this.itemRemove);
			this.snackbar = false;
			this.removeStart = true;
		},
		checkRemove(item) {
			this.itemRemove = item;
			this.snackbar = true;
		},
		checkPages(e) {
			if (e != "All") {
				this.itemsPerPage = parseInt(e, 10);
			} else {
				this.itemsPerPage = 999999999;
			}
		},
		goTo(line, index) {
			if (this.permissions["10"] || this.permissions["9"] || this.permissions["57"])
				this.$emit("edit-item", line, index);
		},
		isDate(key) {
			const i = this.header.find(
				(value) => value.value === key && value?.model === "date"
			);
			return !!i;
		},
		isSomeValue(key) {
			const i = this.header.find(
				(value) => value.value === key && value?.filterSplit === true
			);
			return !!i;
		},
		changeSort(val) {
			if (!val && !val?.value.length) {
				this.lengthOfFiltered = null;
			}

			if (val || val?.model === 'number') {
				this.filters[val.key] = val.value;
			}

			let arr = this.dataTable;
			for (const key in this.filters) {
				if (this.filters[key].length) {
					const filter = arr.filter((elem) => {
						const result = [];
						if (this.isDate(key) && elem[key]) {
							if (this.filters[key][0].length > 10) {
								const firstDate =
										new Date(this.filters[key][0]).valueOf() -
										((24 * 60 * 60 * 1000) - 1000);
								const lastDate =
										new Date(this.filters[key][1]).valueOf() +
										((24 * 60 * 60 * 1000) - 1000);
								const currentDate = new Date(elem[key]).valueOf();
								if (currentDate >= firstDate && currentDate <= lastDate)
									result.push(true);
							} else {
								const firstDate = new Date(
									this.filters[key][0] + " 00:00:00"
								).valueOf();
								const lastDate =
										new Date(this.filters[key][1] + " 00:00:00").valueOf() +
										((24 * 60 * 60 * 1000) - 1000);
								const currentDate = new Date(elem[key]).valueOf();
								if (currentDate >= firstDate && currentDate <= lastDate)
									result.push(true);
							}
						} else if (!this.isDate(key) && this.isSomeValue(key) && elem[key]) {
							for (let i = 0; i < this.filters[key].length; i++) {
								if (new RegExp(String(this.filters[key][i]).trim(), "i").test(String(elem[key]).trim())) {
									result.push(true);
								}
							}
						} else if (!this.isDate(key) && !this.isSomeValue(key) && elem[key]) {
							for (let i = 0; i < this.filters[key].length; i++) {
								if (String(this.filters[key][i]).toLowerCase().trim() === String(elem[key]).toLowerCase().trim()) {
									result.push(true);
								}
							}
						}

						return result.length;
					});
					arr = filter;
					this.lengthOfFiltered = arr.length;
				}
			}
			this.filterClasses = this.filters;
			this.list = arr;
			if (val) {
				this.setListsFilter(this.list, val.key);
			} else {
				this.setListsFilter(this.list);
			}
		},
		refreshFilters() {
			this.lengthOfFiltered = null;
			this.sortBy = "";
			this.search = "";
			this.itemsPerPage = 20;
			this.countItemsVal = 20;
			this.list = this.dataTable;
			if (Object.values(this.filterClasses).includes(true)) {
				for (const i in this.filters) {
					this.filters[i] = [];
				}
				this.filterUpdate = true;
			}

			this.setListsFilter(this.list);
		},
		createRefresh(model) {
			this.filtersMarker[model] = true;
			if (!Object.values(this.filtersMarker).includes(false)) {
				this.filterUpdate = false;
				for (const i in this.filtersMarker) {
					this.filtersMarker[i] = true;
				}
			}

			this.filterClasses = this.filters;
		},
		setListsFilter(arr, key) {
			if (key) {
				for (const i in this.filtersList) {
					if (key !== i) {
						this.filtersList[i] = [];
					}
				}
			} else {
				for (const i in this.filtersList) {
					this.filtersList[i] = [];
				}
			}

			for (let i = 0; i < arr.length; i++) {
				for (const prop in arr[i]) {
					const sp = this.header.find((value) => value.filterSplit && value.value === prop);
					if (sp) {
						if (this.listValues.includes(prop)) {
							if (arr[i][prop]) {
								const valDetect = arr[i][prop]?.split(",");
								for (const spItem of valDetect) {
									this.filtersList[prop].push(spItem.trim());
								}
							}
						}
					} else if (this.listValues.includes(prop)) {
						this.filtersList[prop].push(arr[i][prop]);
					}
				}
			}
		},
		onCustomSort(items, [ index ], [ isDesc ]) {
			items.sort((a, b) => {
				if (index === "delivery_datetime" || index === "pick_up_datetime") {
					const [ month, days, years ] = a[index].split('-');
					const [ monthSecond, daysSecond, yearsSecond ] = b[index].split('-');

					if (!isDesc) {
						return years + month + days < yearsSecond + monthSecond + daysSecond ? -1 : 1;
					}
					return yearsSecond + monthSecond + daysSecond < years + month + days ? -1 : 1;

				}
				if (!isDesc) {
					return a[index] < b[index] ? -1 : 1;
				}
				return b[index] < a[index] ? -1 : 1;

			});
			return items;
		},
		toggleOrder(val) {
			this.sortBy = val;
			this.sortDesc = !this.sortDesc;
		},
		filterCreated(model) {
			this.filtersMarker[model] = false;
		},
	},
	watch: {
		dataTable(val) {
			this.list = val;
		},
		dataTablelength() {
			if (this.removeStart) {
				// let index = this.list.indexOf(this.itemRemove);
				// this.list.splice(index, 1);
				this.setListsFilter(this.list);
				this.removeStart = false;
			} else {
				this.changeSort();
			}
		},
		search(val) {
			const arr = this.dataTable.slice();
			this.list = arr.filter((item) => {
				const res = [];
				for (const obj in item) {
					res.push(new RegExp(val, "i").test(String(item[obj])));
				}

				return res.includes(true);
			});
			this.setListsFilter(this.list);
		},
		update(val) {
			if (val) {
				this.setListsFilter(this.list);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
//@import "./table.module";
@import "tableModule";
</style>
<style lang="scss">
@import "tableModuleAll";
</style>
